import styled from 'styled-components';
import { fonts, colours } from '../../styles/theme';

export const RequiredStyled = styled.span`
  ${fonts.font1.H17B};
  color: ${colours.colour7};
  margin: -0.2rem 0 0 0.5rem;
`;
